import { Card, DebitAccount, OrderCardStatus, SessionUser } from '@generated-types';

import {
    hasOrderStatus,
    idemiaIsProducing,
    isHardBlocked,
    isSystemSoftBlocked,
    userIsOwnerOfCardAccount,
} from './card-utils';
import { isOver18 } from './user-utils';

const cardIsSentToCustomer = (card: Card) => card.orderStatus === OrderCardStatus.SENT_TO_CUSTOMER;

const cardIsBlockable = (card: Card, account: DebitAccount): boolean => {
    if ('paymentStatus' in account) {
        return false;
    }

    if (hasOrderStatus(card)) {
        return false;
    }

    if (idemiaIsProducing(card) && !cardIsSentToCustomer(card)) {
        return false;
    }

    if (isSystemSoftBlocked(card)) {
        return false;
    }

    return !isHardBlocked(card);
};

export const userCanBlockCard = (card: Card, user: SessionUser, account: DebitAccount) => {
    if (!cardIsBlockable(card, account)) {
        return false;
    }

    if (!isOver18(user)) {
        return false;
    }

    if (userIsOwnerOfCardAccount(card, user?.userId)) {
        return true;
    }

    return card.allowedOperations.softBlock;
};
